import React, { useContext, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import styles from "../../../Styles/ComponentStyles/MainPages/Member.module.scss"
import globalStyles from "../../../Styles/global.module.scss"

import { Pagination, PaginationItem, Stack, Typography } from '@mui/material';
import GlobalSelect from '../../../Utils/Layout/GlobalSelect/GlobalSelect';
import GlobalButton from '../../../Utils/Layout/GlobalButton/GlobalButton';
import AddIcon from '@mui/icons-material/Add';
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from '@mui/x-data-grid';
import { MemberContext, MemberContextPayload } from '../../../Context/MemberDetailsContext';
import { GlobalUserContext, GlobalUserContextPayload } from '../../../Context/GlobalUserDetailContext';
import { useSnackbar } from '../../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';
import agent from '../../../Services/api';
import GlobalDialog from '../../../Utils/Layout/GlobalDialog/GlobalDialog';
import AcrylicNewMemberDialog from './AcrylicDialogs/AcrylicNewMemberDialog';

const AcrylicTeam = () => {

    const {
        memberUserListDetails,
        userCredentialListDetails,

        acrylicTeamListDetails,
        setAcrylicTeamListDetails
    } = useContext(MemberContext) as MemberContextPayload

    const {
        flagLoader,
        setFlagLoader,
    } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const { showSnackbar } = useSnackbar();
    const [flagOpenNewMemberDialog, setFlagOpenNewMemberDialog] = useState(false)


    // const initializeAcrylicTeamListAuth = async (userId: number | null = null) => {
    //     const payload = {
    //         userId: userId ?? null,
    //         flagGetAll: userId === null
    //     };

    //     setFlagLoader(true);
    //     const response = await agent.getAcrylicTeamMemberApi.get(payload);
    //     console.log("response of getAcrylicTeamMemberApi", response);


    //     if (response?.status && response?.data) {
    //         setAcrylicTeamListDetails(response.data);
    //     } else {
    //         const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
    //         showSnackbar(errorMessage, 'error');
    //     }

    //     setFlagLoader(false);
    // };


    // useEffect(() => {
    //     initializeAcrylicTeamListAuth()
    // }, [])


    const columns = [
        {

        }
    ]

    const CustomToolbar = () => (
        <GridToolbarContainer
            sx={{
                color: '#fff',
                marginBottom: '10px',
                '& .MuiButtonBase-root': {
                    color: '#fff',
                    fontWeight: 500,
                    fontSize: '14px',
                    textTransform: 'uppercase',
                },
            }}
        >
            <GridToolbarColumnsButton />
            <GridToolbarFilterButton />
            <GridToolbarDensitySelector />
            <GridToolbarExport />
        </GridToolbarContainer>
    );


    return (
        <>

            {flagOpenNewMemberDialog &&
                <GlobalDialog
                    flagHeadSection={true}
                    maxWidth="md"
                    dialogHead="New Member"
                    open={flagOpenNewMemberDialog}
                    view={
                        <AcrylicNewMemberDialog
                            flagOpenNewMemberDialog={flagOpenNewMemberDialog}
                            setFlagOpenNewMemberDialog={setFlagOpenNewMemberDialog}
                        />
                    }
                    onClose={() => { setFlagOpenNewMemberDialog(false) }}
                />
            }

            <Grid container>
                <Grid size={{ xs: 12 }} className={styles.atMainItem}>
                    <Grid container>
                        <Grid size={{ xs: 12 }}>
                            <Grid container>
                                <Grid size={{ xs: 4 }}>
                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV20} `}>
                                        Acrylic Team
                                    </Typography>
                                </Grid>
                                <Grid size={{ xs: 8 }}>
                                    <Grid container sx={{ justifyContent: 'end', gap: "20px", alignItems: "center" }}>
                                        <Grid size={{ xs: 4 }}>
                                            <GlobalSelect
                                                size='small'
                                                fullWidth
                                                className={`${globalStyles.gblDropdownStyles}`}
                                            // value={storedExistingMemberDetails?.userStatus?.id || ""}
                                            // options={
                                            //     memberUserListDetails?.email?.length
                                            //         ? memberUserListDetails.userStatus.map((status: any) => ({
                                            //             label: status.user_status_Desc,
                                            //             value: status.user_status_id
                                            //         }))
                                            //         : []
                                            // }
                                            // onChange={(e) => {
                                            //     const selectedId = Number(e.target.value);
                                            //     const matched = userStatusList?.userStatus.find(
                                            //         (status) => status.user_status_id === selectedId
                                            //     );
                                            //     if (matched) {
                                            //         handleInputChange("userStatus", {
                                            //             id: matched.user_status_id,
                                            //             status: matched.user_status_Desc
                                            //         });
                                            //     }
                                            // }}
                                            />
                                        </Grid>
                                        <Grid size={{ xs: 2 }} className={styles.atCloseBtnStyleItem}>
                                            <GlobalButton
                                                fullWidth
                                                value='Add Member'
                                                size='medium'
                                                className={styles.atCloseBtnStyle}
                                                startIcon={<AddIcon />}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <Grid container>
                                {/* <Stack className={styles.paginationStack}>
                                    <Pagination
                                        count={Math?.ceil(memberUserListDetails?.length / rowsPerPage)}
                                        page={page}
                                        siblingCount={0}
                                        boundaryCount={1}
                                        onChange={handlePageChange}
                                        className={globalStyles.gblPaginationStyles}
                                        sx={{ "& .MuiPaginationItem-ellipsis": { color: "black" } }}
                                        renderItem={(item) => (
                                            <PaginationItem
                                                {...item}
                                                sx={{
                                                    "&.Mui-selected": {
                                                        backgroundColor: "#4A6086",
                                                        color: "white",
                                                        "&:hover": {
                                                            backgroundColor: "#4A6086",
                                                            color: "white",
                                                        },
                                                    },
                                                    backgroundColor: "#ffffff",
                                                    borderRadius: "8px",
                                                    color: "#000000",
                                                    "&:hover": {
                                                        backgroundColor: "#ffffff",
                                                        color: "#000000",
                                                    },
                                                }}
                                            />
                                        )}
                                    />
                                </Stack> */}

                                <Grid size={{ xs: 12 }} sx={{ margin: "20px 0px 0px" }}>
                                    {/* <DataGrid
                                        rows={memberUserListDetails}
                                        columns={columns}
                                        autoHeight
                                        density='standard'
                                        getRowId={(row) => row.userId}
                                        className={globalStyles.globalDatagridStyles}
                                        // pageSizeOptions={[10, 25, 50]}
                                        pagination
                                        paginationModel={{ pageSize: 15, page: 0 }}
                                        checkboxSelection={false}
                                        disableRowSelectionOnClick
                                        hideFooterPagination
                                        rowHeight={50}
                                        columnHeaderHeight={50}
                                        slots={{
                                            toolbar: CustomToolbar,
                                        }}
                                        onPaginationModelChange={(model) => {
                                            setPage(model.page);
                                            setRowsPerPage(model.pageSize);
                                        }}
                                    /> */}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default AcrylicTeam